import React from "react";
import { withStyles } from "@material-ui/core";
import { Switch as MuiSwitch } from "@material-ui/core";

const Switch = ({ id, checked, handleChange, disabled = false }) => {
  const AntSwitch = withStyles((theme) => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: "flex",
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      "&$checked": {
        transform: "translateX(12px)",
        color: theme.palette.common.white,
        "& + $track": {
          opacity: 1,
          backgroundColor: "#cca326",
          border: "none",
        },
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: "none",
      color: "#fff",
    },
    track: {
      height: "unset",
      borderRadius: 26 / 2,
      backgroundColor: "#ccc",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"]),
    },
    disabled: {
      "&$checked": {
        transform: "translateX(12px)",
        color: theme.palette.common.white,
        "& + $track": {
          opacity: 1,
          backgroundColor: "#ccc",
          border: "none",
        },
      }
    },
    checked: {},
  }))(MuiSwitch);
  return (
    <AntSwitch
      id={id}
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default Switch;
